import React, { useLayoutEffect } from 'react'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import TiledMenuContainer from 'redux/containers/components/tiled-menu/TiledMenuContainer'
import NotFound from 'components/NotFound'

const TiledMenuConsumer = ({
  tiledMenu,
  'data-help-item': dataHelpItem,
  setIsTiledMenu,
  setTiledMenuIsLoaded,
  ...props
}) => {
  const handleOnBadData = () => setTiledMenuIsLoaded(true)

  return (
    <ResponseConsumer
      response={tiledMenu}
      {...{ handleOnBadData }}
      skeleton='tiled-menu'
      content={() => <TiledMenuContainer {...{ tiledMenu, dataHelpItem, ...props }} />}
      notfoundComponent={() => <NotFoundComponent {...{ tiledMenu, setIsTiledMenu, setTiledMenuIsLoaded }} />}
    />
  )
}

const NotFoundComponent = ({ tiledMenu, setIsTiledMenu, setTiledMenuIsLoaded }) => {
  useLayoutEffect(() => {
    setTiledMenuIsLoaded(true)
    return () => {
      setTiledMenuIsLoaded(false)
      setIsTiledMenu(false)
    }
  }, [])

  return <NotFound message={`network error: ${tiledMenu}`} />
}

export default TiledMenuConsumer
